<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/VpLTIK/tc-custom/cover.jpg?1684274264672?1720272536204" alt="This image is the cover for the book Hidden History of Richmond, Hidden History"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hidden History of Richmond, Hidden History
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The lesser-known tales of the personalities who shaped the capital's past are unearthed from the archives by Richmond Guide writer Walter S. Griggs Jr.</b></p><br/><p>The course of Richmond's history as it emerged from the Civil War as a bustling economic powerhouse is well recorded. Yet there are some stories that have all but vanished from recollection. From the hushed whispers of an entire congregation as Robert E. Lee prayed with a slave at communion to the donation of over two hundred pigeons by fellow Richmonders to serve the war effort, these are lost vignettes of Richmond. Travel with Griggs to the bygone days of the twentieth century to test-drive the first successful automobile manufactured in Richmond, the Kline Kar, or witness the first airplane to fly over Richmond, the Gold Bug soaring over the Diamond. Hidden History of Richmond is a fascinating collection that reveals the city's forgotten but most remarkable histories.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Walter S. Griggs Jr.
      </h2>
      
      <p class="authorDescription body article">Dr. Walter Griggs Jr. is a law professor at Virginia Commonwealth University. He holds an MA and JD from the University of Richmond and PhD from William and Mary. He has written numerous articles and books on a variety of historical subjects and was awarded the Jefferson Davis Medal for his work.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8720670a